const { POLYGON_PATH } = require('../constants/paths');
const polygonClient = require('../client/restclient')({
  timeout: 5000,
  baseURL: '/',
  retry: {
    maxRetries: 1,
    delay: 0,
  },
});

class PolygonService {
  static simplifyPolygon(polygon) {
    return polygonClient
      .post(`${POLYGON_PATH}`, {
        headers: {
          'Content-Type': 'application/json',
          Encoding: 'UTF-8',
          'x-client-name': 'web',
        },
        data: {
          polygon,
        },
      })
      .then((response) => response.data);
  }
}

module.exports = PolygonService;
